export default __webpack_public_path__ + "static/media/normal.9c141388.svg";